import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {toast} from "react-toastify";
import DepartmentService from "../../shared/service/DepartmentService";
import {InputNumber} from "primereact/inputnumber";
import {PRODUCT_TYPE, PRODUCT_UNIT} from "../../shared/utils/Constants";
import ProductService from "../../shared/service/ProductService";
import {Checkbox} from "primereact/checkbox";
import '../../shared/styles/SettingsPage.css';


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    departmentId: null,
    departmentProfitMargin: null,
    departmentTaxId: null,
    tax: null,
    price: null,
    oldPrice: null,
    webPrice: null,
    price2: null,
    price3: null,
    unit: 'each',
    quantity: 1,
    weighable: false,
    allowZeroPrice: false,
    allowNegativePrice: false,
    productType: 'PRODUCT_LINE',
    fileType: '',
    fileName: '',
    fileTypeTill: '',
    fileNameTill: '',
    productTags: [],
    mixAndMatchName: '',
    minStock: null,
    maxStock: null,
    supplierId: null,
    countryId: null,
    productClassId: null,
    description: '',
    rowNumber: 1000,
    colNo: 10,
    costPrice: 0,
    boxQuantity: null,
    boxUnit: 'each',
    profitMargin: null,
    boxPrice: 0,
    unitCost: 0,
    actualMargin: null,
    retailPrice: 0,
    codeLength: 7
};

export default class ProductBulkSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productTemp: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
            departmentList: [],
        }
        this.departmentService = new DepartmentService();
        this.productService = new ProductService();
    }

    componentDidMount() {
        this.departmentService.findAll().then(response => this.setState({departmentList: response}));
        this.generateNextBarcode();
    }

    clearData = () => {
        this.setState({
            product: Object.assign({}, defaultProduct),
            productTemp: Object.assign({}, defaultProduct),
        });
    }

    render() {
        const showWeighable = (this.state.product.barcode?.length ?? 0) < 5 &&
            (this.state.product.barcode?.length ?? 0) !== 0;

        return (
            <div className="settings-page settings-page--dialog">
                <h2 className="settings-page__section-title">Product Definition</h2>

                <div className="settings-page__filter settings-page__filter--form">
                    <div className={`settings-page__filter-row settings-page__filter-row--barcode-toolbar settings-page__form-fields${showWeighable ? ' settings-page__filter-row--with-weighable' : ''}`}>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-barcode">
                                    <Translate contentKey="producttradingName">Barcode</Translate>
                                </Label>
                                <AvField
                                    id="bulk-barcode"
                                    type="number"
                                    className="form-control"
                                    name="barcode"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    max="99999999999999"
                                    value={this.state.product.barcode}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>

                        {showWeighable &&
                            <div className="settings-page__filter-field settings-page__filter-field--checkbox-inline">
                                <div className="settings-page__checkbox-item">
                                    <Checkbox
                                        onChange={(e) => this.setChecked("weighable", e.checked)}
                                        name="weighable"
                                        disabled={!this.state.productDetailsSaveButtonRender}
                                        checked={this.state.product.weighable}
                                    />
                                    <Label>
                                        <Translate contentKey="productfirstName">Weighable</Translate>
                                    </Label>
                                </div>
                            </div>
                        }

                        <div className="settings-page__filter-field settings-page__filter-field--barcode-action">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action settings-page__btn--nowrap"
                                disabled={!this.state.productDetailsSaveButtonRender}
                                onClick={() => {
                                    this.productService.getNextBarcode().then(response => {
                                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                            let product = this.state.product;
                                            product["barcode"] = response.barcode;
                                            this.setState({product: product});
                                        }
                                    });
                                }}>
                                <Translate contentKey="entity.action.add">Generate Barcode</Translate>
                            </Button>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-name">
                                    <Translate contentKey="producttradingName">Name</Translate>
                                </Label>
                                <AvField
                                    id="bulk-name"
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.name}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-3 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-price">
                                    <Translate contentKey="producttradingName">Price</Translate>
                                </Label>
                                <InputNumber
                                    inputId="bulk-price"
                                    name="price"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.price}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    className="table-responsive"
                                    currency="GBP"
                                    locale="en-US"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-price2">
                                    <Translate contentKey="producttradingName">Price2</Translate>
                                </Label>
                                <InputNumber
                                    inputId="bulk-price2"
                                    name="price2"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.price2}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    className="table-responsive"
                                    currency="GBP"
                                    locale="en-US"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-price3">
                                    <Translate contentKey="producttradingName">Price3</Translate>
                                </Label>
                                <InputNumber
                                    inputId="bulk-price3"
                                    name="price3"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.price3}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    className="table-responsive"
                                    currency="GBP"
                                    locale="en-US"
                                />
                            </AvGroup>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__form-fields">
                        <div className="settings-page__filter-field settings-page__filter-actions">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action"
                                onClick={() => this.calculateWebPrice()}>
                                <Translate contentKey="entity.action.add">Calculate</Translate>
                            </Button>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-quantity">
                                    <Translate contentKey="producttradingName">Quantity</Translate>
                                </Label>
                                <InputNumber
                                    inputId="bulk-quantity"
                                    name="quantity"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.quantity}
                                    onChange={this.__handleChange}
                                    className="table-responsive"
                                    locale="en-US"
                                />
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-unit">
                                    <Translate contentKey="producttradingName">Unit</Translate>
                                </Label>
                                <AvField
                                    id="bulk-unit"
                                    type="select"
                                    className="form-control"
                                    name="unit"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.unit}
                                    onChange={this.__handleChange}>
                                    {PRODUCT_UNIT.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                    </div>

                    <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-department">
                                    <Translate contentKey="contactManagement.mobilePhone">Department</Translate>
                                </Label>
                                <AvField
                                    id="bulk-department"
                                    type="select"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    className="form-control"
                                    name="departmentId"
                                    value={this.state.product.departmentId}
                                    onChange={this.__handleChange}>
                                    <option value='' key=''/>
                                    {this.state.departmentList.map(element => (
                                        <option value={element.id} key={element.id}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="bulk-product-type">
                                    <Translate contentKey="producttradingName">Product Type</Translate>
                                </Label>
                                <AvField
                                    id="bulk-product-type"
                                    type="select"
                                    className="form-control"
                                    name="productType"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.productType}
                                    onChange={this.__handleChange}>
                                    {PRODUCT_TYPE.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="settings-page__actions">
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--save"
                        onClick={() => this.saveProduct()}>
                        <Translate contentKey="entity.action.add">Save</Translate>
                    </Button>
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--cancel settings-page__btn--close"
                        onClick={() => this.props.closeDisplayDialog()}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    setChecked = (field, checked) => {
        let product = this.state.product;
        product[field] = checked;
        this.setState({product: product});
    }

    generateNextBarcode = () => {
        this.productService.getNextBarcode().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                let product = this.state.product;
                product["barcode"] = response.barcode;
                this.setState({product: product});
            }
        });
    }

    saveProduct = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.product.name) ||
            GeneralUtils.isNullOrEmpty(this.state.product.barcode) ||
            GeneralUtils.isNullOrEmpty(this.state.product.quantity) ||
            GeneralUtils.isNullOrEmpty(this.state.product.departmentId) ||
            GeneralUtils.isNullOrEmpty(this.state.product.unit)
        ) {
            return toast.warn("Please fill the required fields!");
        } else {
            this.productService.create(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let obj1 = Object.assign({}, response);
                        obj1.id = null;
                        obj1.bssId = null;
                        obj1.barcode = null;
                        obj1.name = null;
                        obj1.price = null;
                        obj1.price2 = null;
                        obj1.price3 = null;
                        obj1.webPrice = null;
                        this.setState({
                            product: obj1, productTemp: Object.assign({}, obj1)
                        });
                        this.props.refreshDataTable();
                    }
                });
        }
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        product[e.target.name] = value;
        this.setState({product: product});
    }

    calculateWebPrice = () => {
        let product = this.state.product;
        if (!GeneralUtils.isNullOrEmpty(product.price)) {
            this.productService.calculateWebPrice(product).then(response => {
                product["webPrice"] = response;
                this.setState({product: product});
            });
        }
    }
}

ProductBulkSave.propTypes = {
    order: PropTypes.object
};
